const STEPS = [
  {
    title: "核对域名与来源",
    body: "先在地址栏逐字看域名是否与官方一致，注意 0/O、1/l、-、下划线等易混淆字符。再确认入口来源：直接输入的官方网址、官方应用商店或正规搜索结果可信度高，群聊、短信与弹窗里的陌生链接优先警惕。",
  },
  {
    title: "检查加密与备案",
    body: "看地址栏是否有安全锁、是否为 https。把页脚的公司名与备案编号，拿到工信部 ICP 备案系统里核对主体是否真实存在、是否与页面自称的运营方一致。查不到或信息对不上的，基本可以判定有诈。",
  },
  {
    title: "比对界面与内容",
    body: "官方站通常结构完整、栏目清晰、公告与更新时间连续。仿冒站常出现错别字、残缺版块、过时内容与统一套用的模板图。把 logo 图标、客服入口、帮助中心一一比对，差异明显的就是冒牌。",
  },
  {
    title: "留意每一步索求",
    body: "正规使用不会一上来就索要银行卡、身份证照片或短信验证码。凡是要求“先充值激活”“验证资金流水”“缴纳保证金”的，请立即停下。正规平台升级、开通也大多在站内完成，不需要你私下转账。",
  },
  {
    title: "走官方客服核实",
    body: "拿不准时，别在可疑页面里问，应回到官方公布的客服或举报渠道核实。可以搜一下“品牌名 + 骗局 / 仿冒 / 曝光”，看看近期是否有大量投诉。保持结果存疑就默认先不操作。",
  },
];

export default function Steps() {
  return (
    <section id="steps" className="scroll-mt-20 bg-background-100/60">
      <div className="wrap py-10 md:py-14">
        <div className="max-w-2xl">
          <p className="kicker mb-3">
            <i className="ri-list-check-3"></i>
            五步辨真法
          </p>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">从怀疑到确认，一套可执行的操作流程</h2>
          <p className="mt-3 text-[15px] leading-7 text-foreground-700">
            识别吃瓜官网真假的诀窍，是把“感觉不对劲”变成“证据链清晰”。顺着下面五步走一遍，大多数仿冒都能在完成前被拦下。
          </p>
        </div>

        <ol className="mt-9 grid gap-0 lg:grid-cols-5">
          {STEPS.map((s, i) => (
            <li key={s.title} className="relative flex flex-col">
              <div className="relative rounded-lg border border-background-200 bg-background-50 p-5 lg:mx-2">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-base text-background-50">
                    {i + 1}
                  </span>
                  <h3 className="font-heading text-lg leading-tight text-foreground-950">{s.title}</h3>
                </div>
                <p className="mt-3 text-sm leading-6 text-foreground-700">{s.body}</p>
              </div>
              {i < STEPS.length - 1 && (
                <span
                  aria-hidden="true"
                  className="mx-auto my-2 hidden h-4 w-4 items-center justify-center text-primary-400 lg:flex"
                >
                  <i className="ri-arrow-right-line"></i>
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}